import { FC, useContext, useMemo, useState } from 'react';

import {
  Button,
  ContextMenu,
  Input,
  useContextMenu,
  SearchIcon,
  Table,
} from '@smartshell/ui-kit';
import { useNavigate } from 'react-router-dom';

import { LayoutContext } from 'components/Layout';
import { useServicesRequests } from 'hooks';
import { LocalizationContext } from 'localization';
import { TService } from 'types';

import { useContextMenuItems, UseGetColumns } from './hooks';
import s from './Services.module.scss';

export const Services: FC = () => {
  const { t } = useContext(LocalizationContext);
  const layoutElement = useContext(LayoutContext);

  const [searchStr, setSearchStr] = useState('');

  const { loadedServices, isServicesLoading, deleteService } =
    useServicesRequests();

  const filteredServices = useMemo(
    () =>
      loadedServices.filter(({ title }: { title: string }) =>
        title.toLowerCase().includes(searchStr.toLowerCase())
      ),
    [loadedServices, searchStr]
  );

  const contextMenuItems = useContextMenuItems({
    deleteService,
  });
  const {
    onContextMenu,
    contextMenuData,
    closeContextMenu,
    cursorPosition,
    onTouchMove,
    onTouchEnd,
    onTouchStart,
  } = useContextMenu<TService>();

  const navigate = useNavigate();

  const COLUMNS = UseGetColumns();
  return (
    <div className={s['page-container']}>
      {contextMenuData && cursorPosition && (
        <ContextMenu
          layoutElement={layoutElement}
          data={contextMenuData}
          items={contextMenuItems}
          closeContextMenu={closeContextMenu}
          position={cursorPosition}
        />
      )}
      <div className={s.controls}>
        <Input
          variant="secondary"
          value={searchStr}
          onChange={setSearchStr}
          placeholder={t('services.search.placeholder')}
          leftContent={<SearchIcon color="primary" />}
          className={s['search-input']}
        />
        <Button
          iconName="CirclePlusIcon"
          onClick={() => navigate(`/services/new`)}
        >
          {t('services.add')}
        </Button>
      </div>
      <Table
        data={filteredServices}
        columns={COLUMNS}
        onContextMenu={(event, data) => {
          onContextMenu(event, data);
        }}
        onTouchStart={(event, row) => {
          onTouchStart(event, row);
        }}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
        onRowDoubleClick={(event, row) => navigate(`/services/${row.id}`)}
        emptyDataPlaceholder={t('services.empty.placeholder')}
        className={s.table}
        isLoading={isServicesLoading}
      />
    </div>
  );
};
